import {
    AppUserAgent
} from '../components/core/use-app-user-agent';
import {
    ampLogEvent
} from './amplitude';
import metaEvent, {
    MetaTrackingEventName,
    MetaTrackingTypeEnum
} from './tracking/meta';
import {
    gaClientEvent
} from './tracking/gtag';
import tiktokEvent, { TikTokEvent } from './tracking/tiktok';
import { getCurrentUrlPath, getReferrerPath } from './tracking/utils';

export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

/**
 *
 * @param user
 * @param cookies
 */
export const ccTrialTrack = (user, cookies?) => {
    /* Path returns with '/' and API_HOST ends with '/' so we remove the path one */
    const url = getCurrentUrlPath() || 'https://app.sunnyside.co/checkout-success';
    const referrer = getReferrerPath();

    metaEvent({
        event_name: MetaTrackingEventName.START_TRIAL,
        user,
        url: 'https://app.sunnyside.co/checkout-success',
        cookies,
        trackingType: MetaTrackingTypeEnum.TRACK_SINGLE
    });
    metaEvent({
        event_name: MetaTrackingEventName.PURCHASE,
        user,
        url: 'https://app.sunnyside.co/checkout-success',
        cookies,
        custom_data: {
            currency: 'USD',
            value: 99.99
        },
        trackingType: MetaTrackingTypeEnum.TRACK_SINGLE
    });
    metaEvent({
        event_name: MetaTrackingEventName.SUNNYSIDE_START_TRIAL,
        user,
        url: 'https://app.sunnyside.co/checkout-success',
        cookies,
        custom_data: {
            currency: 'USD',
            value: 99.99
        },
        trackingType: MetaTrackingTypeEnum.TRACK_SINGLE_CUSTOM
    });
    /* Google analytics */
    gaClientEvent({
        action: 'cc_trial_start'
    });
    /* Google ads */
    gaClientEvent({
        action: 'conversion',
        send_to: 'AW-644430336/fya-CNSGucMDEID0pLMC'
    });
    ampLogEvent(
        'signup: start trial fb event',
        {},
        cookies
    );
    /* Tiktok */
    tiktokEvent({
        event_name: TikTokEvent.PURCHASE,
        user,
        url,
        referrer,
        cookies,
        properties: {
            price: 99,
            value: 99,
            quantity: 1,
            currency: 'USD',
            description: 'Annual Sunnyside digital subscription',
            content_ids: 'ss_digital',
            content_type: 'product'
        }
    });
    tiktokEvent({
        event_name: TikTokEvent.START_TRIAL,
        user,
        url,
        referrer,
        cookies,
        properties: {
            price: 99,
            value: 99,
            quantity: 1,
            currency: 'USD',
            description: 'Annual Sunnyside digital subscription',
            content_ids: 'ss_digital',
            content_type: 'product'
        }
    });
    tiktokEvent({
        event_name: TikTokEvent.COMPLETE_REGISTRATION,
        user,
        url,
        referrer,
        cookies,
        properties: {
            price: 99,
            value: 99,
            quantity: 1,
            currency: 'USD',
            description: 'Annual Sunnyside digital subscription',
            content_ids: 'ss_digital',
            content_type: 'product'
        }
    });
};

export const validateEmail = (email: string) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase().trim());
};

export const getAppEventSource = (
    cookies: {[name: string]: any} | undefined, userAgent: AppUserAgent | undefined
): 'ios' | 'web' | 'android' => {
    if (cookies?.ss_app === 'true') {
        return 'ios';
    }
    return userAgent?.os ? userAgent.os : 'web';
};

export const getEventMetaData = (cookies?: {[name: string]: any} | undefined): { event_source: string, event_device: string } => {
    let event_source = 'unknown';
    let event_device = 'unknown';

    let rawUserAgent = '';
    if (typeof window !== 'undefined') rawUserAgent = window?.navigator?.userAgent?.toLowerCase();

    if (cookies?.ss_app === 'true') {
        event_source = cookies?.ss_app_device;
        if (rawUserAgent.includes('ipad')) {
            event_device = 'ipad';
        } else if (cookies?.ss_app_device === 'ios') {
            event_device = 'iphone';
        } else if (cookies?.ss_app_device === 'android') {
            event_device = 'android';
        }
    } else {
        if (rawUserAgent.includes('ipad')) {
            event_source = rawUserAgent.includes('sunnyside') ? 'ios' : 'web';
            event_device = 'ipad';
        } else if (rawUserAgent.includes('iphone')) {
            event_source = rawUserAgent.includes('sunnyside') ? 'ios' : 'web';
            event_device = 'iphone';
        } else if (rawUserAgent.includes('android')) {
            event_source = rawUserAgent.includes('sunnyside') ? 'android' : 'web';
            event_device = 'android';
        } else if (rawUserAgent.includes('linux') || rawUserAgent.includes('windows') || rawUserAgent.includes('mac os')) {
            event_source = 'web';
            event_device = 'computer';
        }
    }

    return {
        event_source,
        event_device
    };
};
